import * as PIXI from 'pixi.js';
import { isConfigFlagEnabled } from '../config';
import { setBombLoaded } from '../redux/actions/sessionActions';
import { ALL_BOMB_PROPERTIES, ALL_BOMB_TYPES } from '../types/bombTypes';
import { delay, isLocalhostEnvironment, isTestEnvironment } from '../utils/utils';
// SINGLETON ALERT!
export const loadedBombSpriteSheets = {};
// SINGLETON ALERT!
// Use a shared promise for each bomb's spritesheet loading to avoid warnings in multi-instance mode when PIXI is asked
// to load bomb textures that have already been loaded.
const sharedBombSpriteSheetLoadingPromises = {};
async function loadBombSpritesheet(imageUrl, data) {
    const texture = await PIXI.Texture.fromURL(imageUrl);
    const spritesheet = new PIXI.Spritesheet(texture, data);
    await spritesheet.parse();
    return spritesheet;
}
async function loadBombSpritesheets(bombType) {
    const { spritesheetProperties: { bomb, bombSplat } } = ALL_BOMB_PROPERTIES[bombType];
    const [bombSpritesheet, bombSplatSpritesheet] = await Promise.all([
        loadBombSpritesheet(bomb.imageUrl, bomb.data),
        loadBombSpritesheet(bombSplat.imageUrl, bombSplat.data)
    ]);
    return {
        bomb: bombSpritesheet,
        bombSplat: bombSplatSpritesheet
    };
}
/**
 * Do not await this function in the caller to ensure it does not block loading of the game and runs in the "background".
 */
export async function startLoadingAllBombsInBackground(dispatch, instanceId) {
    const isParallel = isConfigFlagEnabled('loadBombsInBackgroundInParallel');
    console.log(`💣 [${instanceId}] Start loading bombs in background (in ${isParallel ? 'parallel' : 'series'})...`);
    if (isParallel) {
        const allBombLoadPromises = ALL_BOMB_TYPES.map((bombType, i) => getBombLoadPromise(bombType, i, dispatch, instanceId));
        await Promise.all(allBombLoadPromises);
    }
    else {
        let bombIndex = 0;
        for (const bombType of ALL_BOMB_TYPES) {
            await getBombLoadPromise(bombType, bombIndex, dispatch, instanceId);
            bombIndex++;
        }
    }
    console.log(`💣 [${instanceId}] Done loading all bombs!`);
}
async function getBombLoadPromise(bombType, bombIndex, dispatch, instanceId) {
    console.log(`💣 [${instanceId}] Loading bomb spritesheet: ${bombType}...`);
    const startMs = performance.now();
    let currBombSpritesheetsPromise = sharedBombSpriteSheetLoadingPromises[bombType];
    if (!currBombSpritesheetsPromise) {
        currBombSpritesheetsPromise = loadBombSpritesheets(bombType);
        sharedBombSpriteSheetLoadingPromises[bombType] = currBombSpritesheetsPromise;
    }
    const { bomb, bombSplat } = await currBombSpritesheetsPromise;
    if (isLocalhostEnvironment() && !isTestEnvironment()) {
        // in local (non-test) environment, simulate slow loading to test bomb buttons that go from 'loading' to 'enabled' modes
        const delayMs = isConfigFlagEnabled('loadBombsInBackgroundInParallel') ? bombIndex * 5000 : 5000;
        await delay(delayMs);
    }
    loadedBombSpriteSheets[bombType] = { bomb, bombSplat };
    // tell redux that the bomb has been loaded, but the actual spritesheet can't be stored in redux:
    dispatch(setBombLoaded(bombType));
    console.log(`💣 [${instanceId}] Done loading bomb spritesheet: ${bombType}, took: ${(performance.now() - startMs).toLocaleString()}ms`);
}
